import { Button, Typography } from "@mui/material";
import { IconImage } from "@/components";
import { delete_img, unlock_right } from "@/constants";
import { formatDateOrTime } from "@/utils";
import { StyledContainedButton, StyledContainer } from "./styles";
import { IoMdClose } from "react-icons/io";

export const columns = ({
  handleTriggerModal,
}: {
  handleTriggerModal: (
    item: SPOwnerPartnerTypes,
    type: "delete" | "restrict" | "unblock" | "redirect"
  ) => void;
}): IColumn<SPOwnerPartnerTypes>[] => [
  {
    name: "Partner Name",
    key: "firstName",
    align: "left",
    width: "148px",
    component: (item: SPOwnerPartnerTypes) => (
      <>
        <Typography variant="body2" color={"#030712"}>
          {item.firstName + " " + item.lastName}
        </Typography>
      </>
    ),
  },
  {
    name: "Contract Email",
    key: "email",
    align: "left",
    width: "428px",
  },
  {
    name: "Date Added",
    key: "createdAt",
    align: "left",
    width: "148px",
    component: (item: SPOwnerPartnerTypes) => (
      <>
        <Typography variant="body2" color={"#030712"}>
          {formatDateOrTime(item.createdAt, "date")}
        </Typography>
        <Typography variant="body1" fontSize={"0.75rem"} color={"#8E9494"}>
          {formatDateOrTime(item.createdAt, "time")}
        </Typography>
      </>
    ),
  },
  {
    name: "Total Clients",
    key: "totalClients",
    align: "left",
    width: "148px",
  },
  {
    name: "Actions",
    key: "actions",
    align: "center",
    width: "433px",
    component: (item: SPOwnerPartnerTypes) => (
      <StyledContainer gap="10px">
        {!item.isRestricted ? (
          <StyledContainedButton
            startIcon={<IoMdClose />}
            onClick={(event) => {
              event.stopPropagation();
              handleTriggerModal(item, "restrict");
            }}
            sx={{
              color: "rgba(234, 67, 52, 1)",
            }}
            variant="outlined"
            title="Restrict"
          />
        ) : (
          <StyledContainedButton
            startIcon={<IconImage src={unlock_right} size="auto" />}
            variant="outlined"
            onClick={(event) => {
              event.stopPropagation();
              handleTriggerModal(item, "unblock");
            }}
            sx={{
              color: "rgba(52, 168, 83, 1)",
            }}
            title="Unblock"
          />
        )}
        <Button
          variant="outlined"
          onClick={(event) => {
            event.stopPropagation();
            handleTriggerModal(item, "delete");
          }}
          style={{
            color: "#EA4334",
            borderColor: "#E6E7E7",
            fontWeight: 500,
          }}
        >
          <IconImage src={delete_img} size="auto" />
        </Button>
        <Button
          variant="outlined"
          onClick={(event) => {
            event.stopPropagation();
            handleTriggerModal(item, "redirect");
          }}
          style={{
            color: "#000",
            borderColor: "#E6E7E7",
            fontWeight: 500,
          }}
        >
          View Clients
        </Button>
      </StyledContainer>
    ),
  },
];
